import { MenuItem, Typography, useMediaQuery } from "@mui/material";
import { sections } from "./constants";
import { CustomMenu, CustomTab, MenuButton, TabsContainer } from "./styles";
import { useState } from "react";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
export default function Header() {
    const mobile = useMediaQuery('(max-width:800px)');
    const [anchorOrigin, setAnchorOrigin] = useState('');
    const [menuButtonText, setMenuButtonText] = useState(sections[0]);
    const close = () => {
        setAnchorOrigin('');
    };
    return (
        <>
            {mobile
                ? <>
                    <MenuButton anchorOrigin={{ vertical: "bottom", horizontal: 'bottom' }} onClick={(event) => { setAnchorOrigin(event.target) }} endIcon={anchorOrigin ? <ExpandLessIcon fontSize="30px" /> : <ExpandMoreIcon fontSize="30px" />}>
                        {menuButtonText}
                    </MenuButton>
                    <CustomMenu open={anchorOrigin} anchorEl={anchorOrigin} onClose={close}>
                        {sections.map((eachSection) => <MenuItem onClick={() => { window.location.hash = eachSection; close(); setMenuButtonText(eachSection) }}>
                            <Typography>{eachSection}</Typography>
                        </MenuItem>)}
                    </CustomMenu>
                </>
                : <TabsContainer variant="fullWidth" value={false}>
                    {sections.map((eachSection, index) => <CustomTab key={index} onClick={() => { window.location.hash = eachSection }} label={eachSection} />)}
                </TabsContainer>
            }
        </>
    );
}